<template>
  <vx-card no-shadow class="container">
    <!-- Info -->
    <div class="flex mb-2">
      <div class="w-6/12 mr-2">
        <vs-input class="w-full" label-placeholder="Nome" v-model="name"></vs-input>
      </div>
      <div class="w-6/12 ml-2">
        <vs-input class="w-full" label-placeholder="E-mail" v-model="email"></vs-input>
      </div>
    </div>
    <div class="flex mb-2">
      <div class="w-6/12 mr-2">
        <vs-input
          class="w-full"
          label-placeholder="Nova Senha (deixe em branco pra não alterar, mínimo de 8 caracteres)"
          v-model="password"
        ></vs-input>
      </div>
      <div class="w-6/12 ml-2">
        <vs-input
          class="w-full"
          label-placeholder="Confirmar Nova Senha (deixe em branco pra não alterar)"
          v-model="password_confirmation"
        ></vs-input>
      </div>
    </div>

    <!-- Save & Reset Button -->
    <div class="flex flex-wrap items-center justify-end">
      <vs-button class="ml-auto mt-2" @click="save">Salvar</vs-button>
    </div>
  </vx-card>
</template>

<script>
export default {
  data() {
    return {
      name: '',
      email: '',
      password: '',
      password_confirmation: ''
    };
  },
  mounted() {
    const user = JSON.parse(localStorage.getItem('user'));
    this.name = user.name;
    this.email = user.email;
  },
  methods: {
    save() {
      this.$vs.loading();
      this.$api
        .patch('/api/v1/affiliate/auth/update', {
          name: this.name,
          email: this.email,
          password: this.password,
          password_confirmation: this.password_confirmation
        })
        .then(() => {
          this.$vs.loading.close();
          this.password = '';
          this.password_confirmation = '';

          const user = JSON.parse(localStorage.getItem('user'));
          user.name = this.name;
          user.email = this.email;
          localStorage.setItem('user', JSON.stringify(user));

          this.$vs.notify({
            text: 'Perfil Atualizado',
            color: 'success'
          });
        })
        .catch(error => {
          this.$vs.loading.close();
          this.$vs.notify({
            title: 'Erro',
            text: error.response.data.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          });
        });
    }
  }
};
</script>
